import assignment from '@/api/assignment.api.js'

/*eslint-disable */
export const runAssignment = ({ commit }, data) => {
  return assignment.runAssignment(data)
    .then(response => {
      return response.data;
    })
}
/*eslint-enable */
